import { create } from 'zustand';

interface BillingRequiredState {
  isOpen: boolean;
  message?: string;
  lastTriggeredAt?: number;
  open: (message?: string) => void;
  close: () => void;
}

export const useBillingRequiredStore = create<BillingRequiredState>((set) => ({
  isOpen: false,
  message: undefined,
  lastTriggeredAt: undefined,
  open: (message) =>
    set({ isOpen: true, message, lastTriggeredAt: Date.now() }),
  close: () => set({ isOpen: false, message: undefined }),
}));
